<template>
  <div class="content">
    <el-container>
      <el-container>
        <el-aside width="15%">
          <div class="header-title">
            玖色循回
          </div>
          <el-row class="tac" style="height: 92.9%;">
            <el-col>
              <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                background-color="#00032f"
                text-color="#fff"
                active-text-color="#2197fe"
                @open="handleOpen"
                @close="handleClose">
                <el-submenu index="1">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span>车辆管理</span>
                  </template>
                  <el-menu-item>
                    <router-link to="/home/carOrder/carList">
                      <div class="router-link">报废车辆列表</div>
                    </router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link to="/home/carOrder/usedCarList">
                      <div class="router-link">二手车辆列表</div>
                    </router-link>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <i class="el-icon-user-solid"></i>
                    <span>用户管理</span>
                  </template>
                  <el-menu-item>
                    <router-link to="/home/person/personList">
                      <div class="router-link">
                        用户列表
                      </div>
                    </router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link to="/home/person/addPerson">
                      <div class="router-link">
                        用户新增
                      </div>
                    </router-link>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">
                    <i class="el-icon-user-solid"></i>
                    <span>区域管理</span>
                  </template>
                  <el-menu-item>
                    <router-link to="/home/address/addressList">
                      <div class="router-link">
                        区域列表
                      </div>
                    </router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link to="/home/address/addAddress">
                      <div class="router-link">
                        区域新增
                      </div>
                    </router-link>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="4">
                  <template slot="title">
                    <i class="el-icon-user-solid"></i>
                    <span>集团管理</span>
                  </template>
                  <el-menu-item>
                    <router-link to="/home/group/setGroup">
                      <div class="router-link">
                        添加集团
                      </div>
                    </router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <router-link to="/home/group/groupList">
                      <div class="router-link">
                        集团列表
                      </div>
                    </router-link>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="5">
                  <template slot="title">
                    <i class="el-icon-s-tools"></i>
                    <span>系统设置</span>
                  </template>
                  <el-menu-item>
                    <router-link to="/home/setting/commission">
                      <div class="router-link">
                        手续费设置
                      </div>
                    </router-link>
                  </el-menu-item>
                  <el-menu-item>
                    <!-- <router-link to=""> -->
                      <div class="router-link" @click="backPage" style="color: #d6d6d6;font-size: 12px;">
                        退出
                      </div>
                    <!-- </router-link> -->
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
        <el-main style="width: 85%;">
          <div class="home-router">
            <router-view/>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  export default {
      methods: {
        handleOpen(key, keyPath) {
          console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
          console.log(key, keyPath);
        },
        backPage(){
          window.localStorage.clear()
          this.$router.push('/')
        },
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
  }
  .el-container{
    width: 100%;
    height: 100%;
  }
  .tac{
    background-color: #00032f;
  }
  .el-header{
    padding: 0;
  }
  .header-box{
    height: 100%;
    width: 100%;
    background-color: #00032f;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    justify-content: center;
  }
 .header-title{
   width: 100%;
    height: 7%;
    background-color: #00032f;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
  }
  .home-router{
    width: 96%;
    height: 90%;
    padding: 2%;
    background-color: #ffffff;
  }

</style>



// WEBPACK FOOTER //
// src/view/home.vue